import React from "react";

export const ExistingUsers: React.FunctionComponent = () => {
    window.location.replace('https://riverlee.sharepoint.com/sites/GuestAccess')
    return null;
}